<template>
  <div>
    <b-container fluid id="wrapper-login" class="p-0" :style="{ backgroundImage: `url(${bgImage})` }" v-if="!lumbredocs_v3">
      <LmComponentLoading v-if="loading" fixed />
      <b-row no-gutters>
        <b-col class="col-left hv-100" v-bind:style="{ background: loginBgColor, textAlign: loginTextAlign  }" >
          <div v-if="!errorUserOrPassword">
            <router-link to="/" class="d-flex" v-bind:style="{ justifyContent: loginLogoJustifyContent }">
              <b-img :src="logoHomeImg" fluid alt="Logo" v-bind:style="{ width: loginLogoWidth }" class="logoSite"/>
            </router-link>
            <div v-if="authMode === 'session'">
              <h4 class="mt-4">{{ $t('sign_in') }}</h4>
              <div v-if="isAuthenticated">
                <button id="session-is-authenticated" class="btn btn-primary btn-margin mt-3 buttonLogin" @click="logout()">
                  <i class="mdi mdi-login"></i>
                  Log Out
                </button>
              </div>
              <div v-else-if="sentRestoreEmailSuccessfully" class="mt-3">
                <p>
                  Se envió un e-mail a tu casilla con los pasos para crear una nueva contraseña.
                </p>
                <button
                  class="btn btn-text mt-3 btn-block"
                  @click="sentRestoreEmailSuccessfully = !sentRestoreEmailSuccessfully; forgotPasswordMode = !forgotPasswordMode"
                >
                  {{ $t('sign_in_btn') }}
                </button>
              </div>
              <div v-else>
                <LmTextInput
                  v-if="!loginByEmail"
                  @enter="onSubmit"
                  v-model="form.username"
                  :v="$v.form.username"
                  :label="$t('username')"
                  class="mt-3"
                />
                <LmTextInput
                  v-if="loginByEmail"
                  @enter="onSubmit"
                  v-model="form.email"
                  :v="$v.form.email"
                  :label="$t('email')"
                  class="mt-3"
                />
                <LmPassword
                  @enter="onSubmit"
                  v-model="form.password"
                  :v="$v.form.password"
                  :serverErrorMessage="serverErrorMessage"
                  :label="$t('password')"
                  class="inputPassword"
                  v-if="!forgotPasswordMode"
                />
                <button
                  autofocus
                  id="session-is-authenticated-else"
                  class="btn btn-primary btn-margin buttonLogin"
                  @click="onSubmit"
                >
                  <i class="mdi mdi-login"></i>
                  {{ forgotPasswordMode ? 'Restablecer contraseña' :$t('sign_in_btn') }}
                </button>
                <button
                  v-if="enableForgotPassword"
                  class="btn btn-text btnForgotPassword btn-block"
                  @click="forgotPasswordMode = !forgotPasswordMode"
                >

                  {{ !forgotPasswordMode ? $t('forgot_password_btn') : $t('login_again') }}
                </button>
              </div>
            </div>
            <div v-else>
              <h4 class="mt-4">{{ $t('sign_in') }}</h4>
              <p class="mt-2">{{ $t('sign_in_message') }}</p>
              <button autofocus id="else-sign-in" class="btn btn-primary btn-margin mt-3 buttonLogin" v-if="!isAuthenticated" @click="login()">
                <i class="mdi mdi-login"></i>
                {{ $t('sign_in_btn') }}
              </button>
              <button id="log-out" class="btn btn-primary btn-margin mt-3 buttonLogin" v-if="isAuthenticated" @click="logout()">
                <i class="mdi mdi-login"></i>
                Log Out
              </button>
            </div>
          </div>
          <div v-else class="text-center">
            <router-link to="/" class="d-flex" v-bind:style="{ justifyContent: loginLogoJustifyContent }">
              <b-img :src="logoHomeImg" fluid alt="Logo" v-bind:style="{ width: loginLogoWidth }" class="logoSite"/>
            </router-link>
            <h3 class="mb-3 titulo">No hemos podido identificarte</h3>
            <LmSvgIcon
              icon="LmAccessDeniedIcon"
              wrapperClass="my-4 d-flex align-items-center flex-column"
              text="Los datos que ingresaste no son correctos. Por favor, verificá la información e intentá nuevamente."
              width="12em"
            />

            <div class="wr-buttons-error">
              <button autofocus id="else-sign-in" class="btn btn-primary btn-margin mt-3 buttonLogin" v-if="!isAuthenticated" @click="errorUserOrPassword=false">
                  {{ $t('login_again') }}
              </button>
              <button
                    v-if="enableForgotPassword"
                    class="btn btn-text btnForgotPassword btn-block"
                    @click="forgotPasswordMode = !forgotPasswordMode; errorUserOrPassword=false"
                  >
                    {{ !forgotPasswordMode ? $t('forgot_password_btn') : $t('login_again') }}
              </button>
            </div>
          </div>
        </b-col>
        <b-col class="col-right hv-100 d-none d-xl-block">
          <div class="auth-user-testimonial">
            <h2 class="mb-3">{{ title1 }}</h2>
            <p class="lead">
              <i class="mdi mdi-format-quote-open"></i>
              {{ text }}
              <i class="mdi mdi-format-quote-close"></i>
            </p>
            <p>{{ title2 }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="login-wrapper" :class="{ 'mesa': isOnMesaContext }" v-else>
      <b-row no-gutters class="h-100">
        <b-col md="4" cols="12">
          <form class="login-form" @submit.prevent="onSubmit">
            <div class="d-flex flex-column justify-content-center h-100">
              <div class="mb-5 login-logo">
                <img :src="logoHomeImg" alt="Logo" />
                <h4 class="text-right" v-if="!isOnMesaContext">Rápido, seguro y digital</h4>
              </div>
              <label class="lm-input-label">
                E-Mail
                <input
                  type="email"
                  placeholder="tu@email.com"
                  class="lm-input"
                  :class="{ 'error': $v.form.email.$error }"
                  v-model.lazy="$v.form.email.$model"
                  autocomplete="on"
                >
                <small class="lm-input-caption" v-if="$v.form.email.$error">Campo inválido</small>
              </label>
              <label class="lm-input-label" v-if="!forgotPasswordMode">
                Contraseña
                <input
                  type="password"
                  placeholder="Tu contraseña"
                  class="lm-input"
                  :class="{ 'error': $v.form.password.$error }"
                  v-model.lazy="$v.form.password.$model"
                >
                <small class="lm-input-caption" v-if="$v.form.password.$error">Campo inválido</small>
              </label>
              <button v-if="enableForgotPassword" type="button" class="lm-link align-self-start" @click="forgotPasswordMode = !forgotPasswordMode">
                {{ forgotPasswordMode ? 'Ingresar' : '¿Olvidaste tu contraseña?' }}
              </button>
              <button v-else type="button"
              class="lm-link align-self-start"
              v-b-modal.password-change-disabled-message
              >
                ¿Olvidaste tu contraseña?'
              </button>
              <button type="submit" class="lm-button" :disabled="loading">
                <template v-if="!loading">
                  {{ forgotPasswordMode ? 'Recuperar Contraseña' : 'Ingresar' }}
                </template>
                <template v-else>
                  <i class="mdi mdi-loading lm-button-loading"></i>
                </template>
              </button>
              <img :src="logoLumileWhite" alt="Logo" width="80" class="mt-5">
            </div>
          </form>
        </b-col>
        <b-col md="8" class="d-none d-md-block">
          <section
            class="login-background"
            :style="isOnMesaContext ? 'background-size: 100%' : ''"
          >
            <h1 class="login-title" v-if="!isOnMesaContext">{{loginH1Text}}</h1>
          </section>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="password-change-disabled-message"
      title="Importante"
      :ok-title="$t('close')"
      ok-only
    >
      <div v-html="passwordChangeDisabledMessage"></div>
    </b-modal>
  </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmPassword from '@/components/form/elements/LmPassword'
import store from '@/store'
import { mapState, mapGetters, mapActions } from 'vuex'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

import { generateRoutes } from '@/helpers/LmDynamicRoutes'

export default {
  name: 'Login',
  inject: ['lumbredocs_v3'],
  components: {
    LmTextInput,
    LmPassword,
    LmTreeSelect,
    LmButton
  },
  mixins: [lmToasts],
  data () {
    return {
      form: {
        email: '',
        customer: null,
        password: null
      },
      serverErrorMessage: '',
      loading: false,
      sentRestoreEmailSuccessfully: false,
      forgotPasswordMode: false,
      enableForgotPassword: process.env?.VUE_APP_ENABLE_FORGOT_PASSWORD === 'yes',
      passwordChangeDisabledMessage: process.env?.VUE_APP_LUMBRE_PASSWORD_CHANGE_DISABLED_MESSAGE || 'Lo sentimos, el cambio de contraseña no está habilitado, por favor contacte a su administrador.',
      errorUserOrPassword: false,
      isOnMesaContext: process.env?.VUE_APP_LUMBREDOCS_V3_MESA === 'yes'
    }
  },
  validations: {
    form: {
      email: {
        required: requiredIf(function (val) {
          return this.loginByEmail && val
        }),
        email
      },
      username: {
        required: requiredIf(function (val) {
          return !this.loginByEmail && val
        })
      },
      /* customer: {
        required
      }, */
      password: {
        required
      }
    }
  },
  methods: {
    ...mapActions('notifications', ['getNotifications']),
    onSubmit () {
      this.forgotPasswordMode ? this.onForgotPassword() : this.login()
    },
    async onForgotPassword () {
      this.$v.form.$touch()
      if (!this.$v.form.email.$invalid) {
        this.loading = true
        try {
          await commonsApi.axiosPostWrapper(
            process.env?.VUE_APP_FORGOT_PASSWORD_URL + this.form.email
          )
          this.loading = false
          this.sentRestoreEmailSuccessfully = true
          this.lmToastSuccessMessage('Recibirás un email con los pasos a seguir.', 'Solicitud exitosa')
        } catch (err) {
          // this.lmToastDangerMessage(err.response.data.message, `${err.response.data.type} - ${err.response.data.code}`)
        } finally {
          this.loading = false
        }
      }
    },
    login () {
      if (this.authMode === 'session') {
        this.$v.form.$touch()
        if (!this.$v.form.$pending && !this.$v.form.$error) {
          this.loading = true
          store.dispatch('session/login', this.form)
            .then(async _ => {
              if (process?.env?.VUE_APP_DYNAMIC_ROUTER === 'yes') {
                // Genero las rutas dinamicas para el usuario logueado
                const routes = await generateRoutes()
                // Inserto las rutas en la instancia de vue-router
                routes.forEach(route => {
                  this.$router.addRoute(route)
                })
              }
            })
            .then(_ => {
              // Busco los parámetros de la url para el "redirect"
              const params = new Proxy(new URLSearchParams(location.search), {
                get: (searchParams, prop) => searchParams.get(prop)
              })
              const urlToRedirect = params?.redirect || '/'
              this.$router.push(urlToRedirect)
              if (process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes') {
                this.getNotifications()
              }
            })
            .catch(error => {
              // if (typeof error.response.data.message !== 'undefined') {
              //   this.serverErrorMessage = error.response.data.message
              //   console.log('error.response.data.message', error.response.data.message)
              // }
              console.log(error)
              // this.lmToastDangerMessage('Email o contraseña inválida.', 'Error')
              this.errorUserOrPassword = true
            })
            .finally(_ => {
              this.loading = false
            })
        }
      } else {
        store.dispatch('session/login', {})
      }
    },
    logout () {
      store.dispatch('session/logout')
    },

    // Evito que el background se carge de manera escalonada (fix visual)
    showBgWhenIsLoaded () {
      const src = this.bgImage
      const image = new Image()
      image.addEventListener('load', function () {
        document.querySelector('.login-background').style.backgroundImage = `url(${src})`
      })
      image.src = src
    }
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('settings', ['appName', 'logoHomeImg', 'title1', 'title2', 'text', 'bgImage', 'loginBgColor', 'loginLogoWidth', 'loginLogoJustifyContent', 'loginTextAlign', 'customerList', 'logoLumileWhite', 'loginH1Text']),
    authMode () {
      return process.env.VUE_APP_AUTH_MODE
    },
    loginByEmail () {
      if (process.env?.VUE_APP_SESSION_LOGIN_BY_EMAIL === 'yes') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.replace('/')
    }
    this.form.customer = JSON.parse(localStorage.getItem('currentCustomer'))

    if (this.lumbredocs_v3) {
      this.showBgWhenIsLoaded()
    }
  },
  mounted () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
.login-wrapper
  padding: 0
  height: 100vh

@keyframes spin
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.login-logo
  width: 90%

// Mesa classes
.mesa
  .login-logo
    width: 100%
    text-align: center
  .login-form
    color: #6c757d
    background: white
    .lm-link
      color: #6c757d
      border-bottom: 1px solid rgba(0, 0, 0, .4)
    .lm-button
      color: white
      background: #007bff

.login-form
  color: white
  padding: 0 20%
  height: 100%
  background: rgb(255,21,99)
  background: linear-gradient(90deg, rgba(255,21,99,1) 0%, rgba(176,58,135,1) 100%)

  .lm-button
    text-transform: uppercase
    background-color: white
    color: black
    border-radius: 20px
    border: none
    padding: 8px 20px
    margin-top: 40px
    font-weight: bold
    transition: all .4s ease-in-out
    &:disabled
      cursor: not-allowed
      background-color: rgba(232, 232, 232, .9)
    &:hover
      transform: scale(1.02)
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
    .lm-button-loading::before
      font-weight: bold
      animation-name: spin
      animation-duration: 1000ms
      animation-iteration-count: infinite
      animation-timing-function: linear
  .lm-link
    display: inline
    background: transparent
    color: white
    border: none
    border-bottom: 1px solid rgba(255, 255, 255, .4)
  .lm-input-label
    font-weight: bold
    display: flex
    flex-direction: column
  .lm-input
    font-weight: bold
    margin-top: 8px
    height: 42px
    border: none
    border-radius: 20px
    padding: 0 20px
    color: black
    background-color: rgba(241, 241, 241, .5)
    transition: all .4s ease-in-out
    &:focus
      outline: none
      box-shadow: 0 0 0 0.25rem rgba(58, 66, 165, .4)
    &::placeholder
      color: #4F4F4F
    &.error
      box-shadow: 0 0 0 0.25rem rgba(197, 0, 0, .4)
  .lm-input-caption
    letter-spacing: .075rem
    font-size: .7rem
    padding: 6px 20px
    color: white

.login-background
  height: 100%
  background-color: white
  background-repeat: no-repeat
  background-attachment: fixed
  background-position: center
  background-size: 80%
  position: relative

.login-title
  width: 50%
  color: #3B43A6
  font-size: 2.6rem
  position: absolute
  top: 15%
  left: 5%

#wrapper-login
  background-position: center
  background-size: cover
  .col-left
    padding: 50px 55px
    max-width: 480px
    width: 100%
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    @media(max-width: $xl)
      max-width: none
      padding: 72px 56px
    .logoSite
      margin: 0 auto
      display: block
    h4
      font-size: 18px
      font-weight: 700
      color: $primaryFontThemeColor
    p
      color: $mutedFontThemeColor!important
      font-size: 14px
      font-weight: 400
    .buttonLogin
      box-shadow: 0 1px 10px 0 rgba(114,124,245,.0) !important
      // box-shadow: rgba(114,124,245, 0.3) 0px 3px 8px !important
      width: 100%
      color: #fff
      font-size: 14px
      font-weight: 400
      padding: 9px
      margin-top: 4px
  .col-right
    padding: 6rem 3rem
    -webkit-box-flex: 1
    -ms-flex: 1
    flex: 1
    position: relative
    color: #fff
    text-align: center
    .auth-user-testimonial
      position: absolute
      margin: 0 auto
      padding: 0 1.75rem
      bottom: 3rem
      left: 0
      right: 0
      h2
        font-weight: 700
      p
        font-size: 14px
        &.lead
          font-weight: 400
          font-size: 18px
  .footer
    bottom: 0
    padding: 19px 30px 20px
    position: absolute
    right: 0
    color: $mutedFontThemeColor
    width: 100%
    text-align: center
  .btn-text
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px;
    padding: 9px
  .btnForgotPassword
    margin-top: 22px
  .inputPassword
    margin-top: -3px
  .invalid-feedback
    margin-bottom: 0px !important
  .wr-buttons-error
    margin-top: 5px
    .btnForgotPassword
      margin-top: 16px
  .titulo
    margin-top: 14px
</style>
